import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import client, { imgUrl, shuffled } from "@/lib/glossyApi";
import MiniAd from "@/components/MiniAd";
import MagazineLayout from "@/components/MagazineLayout";

export default function Interviews() {
  const [articles, setArticles] = useState([]);
  useEffect(() => {
    document.title = "The Interviews — S/ME";
    client.get("/articles?type=five_questions&limit=60").then((r) => setArticles(shuffled(r.data))).catch(() => {});
  }, []);

  const [lead, ...rest] = articles;

  return (
    <MagazineLayout>
      <div className="pt-[68px] bg-cream min-h-screen" data-testid="interviews-page">
        <header className="px-5 sm:px-8 pt-16 sm:pt-24 pb-10 max-w-[1600px] mx-auto">
          <p className="overline text-gloss-silver mb-4">Cover Stories</p>
          <h1 className="font-serif text-5xl sm:text-7xl lg:text-8xl tracking-tight leading-none">The Interviews</h1>
          <p className="font-sans text-lg text-ink/70 mt-5 max-w-xl">Every member gets their moment — a full cover shoot and feature. This is where the UK's independents become the stars.</p>
        </header>

        <div className="px-5 sm:px-8 max-w-[1600px] mx-auto mb-10"><MiniAd variant="banner" mode="image" space="interviews_band" /></div>

        <section className="px-5 sm:px-8 pb-28 max-w-[1600px] mx-auto">
          {articles.length === 0 && <p className="font-sans text-ink/50 py-20 text-center border-t border-ink/20">The first interviews are being shot now — check back soon.</p>}

          {lead && (
            <Link to={`/read/${lead.slug}`} className="group block relative overflow-hidden aspect-[16/10] sm:aspect-[16/7] mb-10 ed-frame" data-testid="interview-lead">
              {imgUrl(lead) && <img src={imgUrl(lead)} alt={lead.title} className="absolute inset-0 w-full h-full object-cover ed-grade transition-transform duration-700 group-hover:scale-105" />}
              <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/30 to-transparent" />
              <div className="absolute bottom-0 left-0 p-6 sm:p-12 text-cream max-w-3xl">
                <p className="overline text-gloss-gold mb-3">The Interview</p>
                <h2 className="font-serif text-4xl sm:text-6xl tracking-tight leading-[0.95]">{lead.title}</h2>
                {lead.dek && <p className="font-sans text-lg text-cream/80 mt-4 hidden sm:block">{lead.dek}</p>}
              </div>
            </Link>
          )}

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {rest.map((a) => (
              <Link key={a.id} to={`/read/${a.slug}`} className="group block relative overflow-hidden aspect-[3/4] ed-frame" data-testid="interview-card">
                {imgUrl(a) && <img src={imgUrl(a)} alt={a.title} className="absolute inset-0 w-full h-full object-cover ed-grade transition-transform duration-700 group-hover:scale-105" />}
                <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/20 to-transparent" />
                <div className="absolute bottom-0 left-0 p-6 text-cream">
                  <p className="overline text-gloss-gold mb-2">Interview</p>
                  <h3 className="font-serif text-2xl tracking-tight leading-tight">{a.title}</h3>
                </div>
              </Link>
            ))}
          </div>
        </section>
      </div>
    </MagazineLayout>
  );
}
